import React, { Component } from 'react'
import styled from 'styled-components'
import { OnSiteLink, UL, Link } from 'atoms'
import { ConfigConsumer } from 'contexts/config-context'
import Submenu from '../Submenu'

const StyledLink = styled(Link)`
    color: #FFF;
    padding: 16px;
    display: inline-block;
    cursor: pointer;

    &:visited, &:hover, &:link {
        color: #FFF;
    }
`

const MainNavLink = styled(OnSiteLink)`
    color: #FFF;
    padding: 16px;
    display: inline-block;
    cursor: pointer;

    &:visited, &:hover, &:link {
        color: #FFF;
    }
`

const ItemsList = UL.extend`
    list-style-type: none;
    margin: 0 0 0 16px;

    &:hover a {
        opacity: .6;
    }

    .is-expanded a, a:hover {
        opacity: 1;
    }
`

const NavItem = styled.li`
    display: inline-block;
    padding: 0;
    
    .Collapsible {
      border-bottom: 1px solid #E2E2E2;
      
      a { cursor:pointer; }
      
      .Collapsible__contentInner > div {
        border-bottom: none;
      }
    }
`

class MainNavItems extends Component {
  render () {
    return (
      <ConfigConsumer>
        {config => (
          <ItemsList>
            {
              config.navItems.map((navItem, index) => {
                return (
                  <NavItem key={`MainNavItem-${index}-${navItem.text}`}>
                    {
                      navItem.subItems !== undefined
                        ? <Submenu items={navItem.subItems} onSiteLink={true}>
                          <StyledLink href={navItem.url} data={navItem.data}>{navItem.text}</StyledLink>
                        </Submenu>
                        : <MainNavLink href={navItem.url} data={navItem.data}>{navItem.text}</MainNavLink>
                    }
                  </NavItem>
                )
              })
            }
          </ItemsList>
        )}
      </ConfigConsumer>
    )
  }
}

export default MainNavItems



// WEBPACK FOOTER //
// ./src/molecules/MainNavItems/MainNavItems.js